import React, { createContext, useContext, useMemo, useState } from 'react';

const AlertContext = createContext(null);

export function AlertProvider({ children }) {
    const [alerts, setAlerts] = useState([]);

    const value = useMemo(() => ({ alerts, setAlerts }), [alerts]);

    return <AlertContext.Provider value={value}>{children}</AlertContext.Provider>;
}

export function useAlertFeed() {
    const context = useContext(AlertContext);

    if (!context) {
        throw new Error('useAlertFeed must be used within AlertProvider');
    }

    return context;
}